import {ApplicationBase} from '../../shared/data-objects/application-base';
import {User} from '../../shared/data-objects/user';
import {WorkrequestLndBaseDetails} from './workrequest-lnd-base-details';

export class LndBase extends ApplicationBase {
  owner: User;
  workrequestDetails: WorkrequestLndBaseDetails;
  isPaymentByCheque: boolean;

  constructor() {
    super();
    this.owner = new User();
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/lnd-w-form/lnd-base.ts